import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Card from 'antd/lib/card';
import Tag from 'antd/lib/tag';
import {
  UNKNOWN,
  platformLabel,
  formatDeviceDate,
} from '../../account-management/components/AccountDetail';

const accountsLabel = count => {
  if (count === null || count === undefined) return UNKNOWN;
  if (count === 1) return `${count} účet`;
  if (count > 1 && count < 5) return `${count} účty`;
  return `${count} účtov`;
};

const deviceLabel = device => {
  const os = [platformLabel(device.platform), device.osVersion].filter(Boolean).join(' ');
  return `${device.deviceName || UNKNOWN} · ${os}`;
};

const Field = ({ label, children }) => (
  <div style={{ flex: '1 1 20%', minWidth: 160, marginBottom: 8 }}>
    <div style={{ color: 'rgba(0,0,0,.45)' }}>{label}</div>
    {children}
  </div>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};

const LoanDeviceSummary = ({ accountId, isAdmin, devices, sameInstallAccountsCount }) => {
  if (!isAdmin || !devices || devices.length === 0) return null;
  const device = devices[0];
  const activeCount = devices.filter(d => d.active).length;
  const title = (
    <span>
      Naposledy aktívne zariadenie účtu{' '}
      <span style={{ color: 'rgba(0,0,0,.43)', fontWeight: 'normal' }}>
        (aktuálne údaje z účtu, nie snímka v čase žiadosti)
      </span>
    </span>
  );

  return (
    <div data-testid="loan-device-summary" style={{ marginBottom: 16 }}>
      <Card title={title}>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Field label="Zariadenie">{deviceLabel(device)}</Field>
          <Field label="Jazyk">{device.appLanguage || UNKNOWN}</Field>
          <Field label="Iné účty z telefónu">
            <Tag color="blue">{accountsLabel(sameInstallAccountsCount)}</Tag>
          </Field>
          <Field label="Aktívne zariadenia">
            {activeCount} · <Link to={`/admin/accounts/${accountId}/profile`}>zobraziť v účte</Link>
          </Field>
          <Field label="Posledná aktivita">{formatDeviceDate(device.lastActiveAt)}</Field>
        </div>
      </Card>
    </div>
  );
};

LoanDeviceSummary.propTypes = {
  accountId: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  devices: PropTypes.array,
  sameInstallAccountsCount: PropTypes.number,
};

LoanDeviceSummary.defaultProps = {
  devices: [],
  sameInstallAccountsCount: null,
};

export default LoanDeviceSummary;



// WEBPACK FOOTER //
// ./src/features/loan-management/components/LoanDeviceSummary.js